.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--zumpo-space-8);
}
